import {
    DWT_PAYLOADS_END_DATE_ELEMENT_ID,
    DWT_PAYLOADS_FACILITY_CODE_ELEMENT_ID,
    DWT_PAYLOADS_RECORD_COUNT_DEFAULT_VALUE,
    DWT_PAYLOADS_RECORD_COUNT_ELEMENT_ID,
    DWT_PAYLOADS_RECORD_COUNT_SELECT_OPTIONS,
    DWT_PAYLOADS_START_DATE_ELEMENT_ID,
    DWT_PAYLOADS_STATUS_ELEMENT_ID,
    DWT_PAYLOAD_REPORT_STATUS_CODE_VALUES,
} from '../../../dwt-payloads/dwt-payloads.constants';
import { DWT_PAYLOADS_STATUS_MULTISELECT_OPTIONS } from '../../../dwt-payloads/dwt-payloads-status-multiselect-options';
import type {
    ReportFilterFieldSpec,
    ReportingTargetFilterDefinition,
} from '../reporting-target-filter.types';

const DWT_DATE_RANGE_ROW = 'dwt-payloads-date-range';

const DWT_PAYLOADS_TARGET_FIELDS: readonly ReportFilterFieldSpec[] = [
    {
        elementId: DWT_PAYLOADS_RECORD_COUNT_ELEMENT_ID,
        label: 'Record Count',
        kind: 'select',
        defaultValue: DWT_PAYLOADS_RECORD_COUNT_DEFAULT_VALUE,
        options: DWT_PAYLOADS_RECORD_COUNT_SELECT_OPTIONS,
    },
    {
        elementId: DWT_PAYLOADS_FACILITY_CODE_ELEMENT_ID,
        label: 'Facility Code',
        kind: 'multiselect',
        placeholder: 'Select one or more facilities',
        options: [],
        visibleSize: 6,
    },
    {
        elementId: DWT_PAYLOADS_START_DATE_ELEMENT_ID,
        label: 'Start date',
        kind: 'date',
        optional: true,
        rowGroup: DWT_DATE_RANGE_ROW,
    },
    {
        elementId: DWT_PAYLOADS_END_DATE_ELEMENT_ID,
        label: 'End date',
        kind: 'date',
        optional: true,
        rowGroup: DWT_DATE_RANGE_ROW,
    },
    {
        elementId: DWT_PAYLOADS_STATUS_ELEMENT_ID,
        label: 'Status',
        kind: 'multiselect',
        placeholder: 'Select status',
        options: DWT_PAYLOADS_STATUS_MULTISELECT_OPTIONS,
        defaultSelectedValues: DWT_PAYLOAD_REPORT_STATUS_CODE_VALUES,
        visibleSize: 3,
    },
];

/**
 * Reporting target: DWT - Payloads to Trace — must match `<option value="...">` in `taskpane.html`.
 */
export const dwtPayloadsReportingTargetDefinition: ReportingTargetFilterDefinition = {
    targetId: 'dwt-payloads-to-trace',
    displayName: 'DWT - Payloads to Trace',
    fetchImplemented: true,
    commonFilterFields: [],
    targetFilterFields: DWT_PAYLOADS_TARGET_FIELDS,
};
